// extracted by mini-css-extract-plugin
module.exports = {"BlogSection":"Blogs_BlogSection__2E8FU","Blogs":"Blogs_Blogs__3B5Uh"};